<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Rede de parceiros';

	let items = [
		{
			nome: 'RODRIGUES & POMAGERSKI ASSESSORIA ADM. LTDA (CONSUPLAN)',
			contato: 'ANDRÉ RODRIGUES',
			telefone: '51 98366773',
			email: 'andresindicoprof@gmail.com'
		},
		{
			nome: 'SINDICARE ORG. CONDOMINIAL',
			contato: 'Nilson Ed. Carla Center',
			celular: '51 999872010',
			email: 'nilson.lampert@gmail.com ',
		},
		{
			nome: 'MONICA DE OLIVEIRA BARBOSA',
			telefone: '51 982734784/996268380',
			email: 'monica.sindica@gmail.com ',
		},
		{
			nome: 'DIAMOND GESTÃO CONDOMINIAL',
			contato: 'Felipe Nunes',
			telefone: '51 985133053/34830910',
			email: 'felipesindicoprofissional@hotmail.com ',
			site: 'www.diamondgestaocondominial.com.br',
		},
		{
			nome: 'IRLES CATARINA BERTONCELLO',
			telefone: '51 91615333',
			email: 'sistemica.sindica@gmail.com ',
		},
		{
			nome: 'PESSI SINDICOS PROFISSIONAIS',
			contato: 'PABLO FEIX PESSI',
			telefone: '51 996740314',
			email: 'pablo@pessisindicos.com.br ',
		},
		{
			nome: 'R2 SINDICOS PROFISSIONAIS',
			contato: 'RAMÃO VICTOR DE ALBUQUERQUE BARBAT',
			telefone: '51 993204498',
			email: 'r2.sindicoprofissional@gmail.com ',
		},
		{
			nome: 'AMA GESTÃO CONDOMINIAL (ANDRE MARQUES AFONSO - ME)',
			contato: 'ANDRÉ / TATIANE',
			telefone: '51 989108206 / 51 992449889',
			email: 'sindico@amagestaocondominial.com.br / gestora@amagestaocondominial.com.br ',
		},
		{
			nome: 'MJ SÍNDICOS PROFISSIONAIS',
			contato: 'Juliana',
			telefone: '51 999989041',
			email: 'juliana@mjsindicos.com.br ',
		},
		{
			nome: 'RC SÍNDICO PROFISSIONAL',
			contato: 'Rafael F. Chalup',
			telefone: '51 992947747',
			email: 'rc.sindicosprofissionais@gmail.com ',
		}
	];
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">
	<p class="mb-30">Com a finalidade de auxiliar na procura de profissionais qualificados na área de Sindico Profissional, relacionamos a seguir alguns empresas parceiras, especialistas na área em referência, que atuam como Síndico Profissional em condomínios geridos por nossa empresa.</p>
	<div class="grid grid-size--2 grid-size-md--2 grid-size-sm--1 gap-20 text-left">
		{#each items as item}
		<div class="background-light-gray round-all pa-20 flex flex-column gap-10">
			<b>{item.nome}</b>
			{#if item.contato}
			<div>Contato: {item.contato}</div>
			{/if}
			{#if item.telefone}
			<div>{item.telefone}</div>
			{/if}
			{#if item.celular}
			<div>{item.celular}</div>
			{/if}
			{#if item.email}
			<div>{item.email}</div>
			{/if}
			{#if item.site}
			<div>{item.site}</div>
			{/if}
		</div>
		{/each}
	</div>
	<p class="mt-30">Os profissionais destacados neste espaço possuem qualificação e desempenham trabalhos com máxima dedicação, conforme acompanhamos a satisfação de nossos clientes. É de inteira responsabilidade das partes envolvidas (contratada e contratante) eventuais negociações, onde orientamos que seja sempre realizada avaliação, negociação de valores e ajustado responsabilidades e garantias através de contrato de prestação de serviço.</p>
	<p>A intenção da Bona Imóveis é auxiliar aos clientes na procura de profissionais do ramo de gestão condominial, bem como expandir o leque de nossos parceiros Síndicos Profissionais na exposição de suas empresas.</p>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/contato" title="Entre em contato" class="btn btn-primary">Entre em contato <i class="far fa-arrow-right"></i></a>
	</div>
</div>